import { render } from "./EmailComposer.vue?vue&type=template&id=16de770e&scoped=true"
import script from "./EmailComposer.vue?vue&type=script&lang=js"
export * from "./EmailComposer.vue?vue&type=script&lang=js"

import "./EmailComposer.vue?vue&type=style&index=0&id=16de770e&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16de770e"]])

export default __exports__